import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'aws-services',
});

export const awsSecretsManagerSubRouteRef = createSubRouteRef({
  id: 'secrets-stats',
  path: '/secrets-stats',
  parent: rootRouteRef,
});
